/* eslint-disable react/function-component-definition */
import React from 'react'
import { Task, ViewMode, Gantt } from './gantt-task-react'
import './gantt-task-react/dist/index.css'
import './style.less'
import TaskListHeader from './components/TaskListHeader'
// import sectionData from './section.json'
type GanttProps = {
  tasks: Task[]
  deliveryDate: Date
  viewMode: ViewMode
  onBarClick?: (task) => void
  onTaskClick?: (task) => void
  onExpanderClick?: (task) => void
}
// Init
export const GanttChart: React.FC<GanttProps> = ({
  tasks,
  onBarClick,
  deliveryDate,
  viewMode,
  onTaskClick,
  onExpanderClick,
}) => {
  let columnWidth = 65
  if (viewMode === ViewMode.Year) {
    columnWidth = 350
  } else if (viewMode === ViewMode.Month) {
    columnWidth = 300
  } else if (viewMode === ViewMode.Week) {
    columnWidth = 250
  }

  return (
    <Gantt
      tasks={tasks}
      viewMode={viewMode}
      onClick={onBarClick}
      listCellWidth={'300px'}
      deliveryDate={deliveryDate}
      columnWidth={columnWidth}
      TaskListHeader={TaskListHeader}
      isShowBarName={false}
      headerHeight={70}
      onTaskClick={onTaskClick}
      todayColor={'rgba(239, 151, 71, 0.2)'}
      onExpanderClick={onExpanderClick}
      barCornerRadius={2}
    />
  )
}
